module.exports = __webpack_public_path__ + "media/images/photo/plans/places/tsurumai_park-1729963d218d099b275f0e8595a0aa0a.png";